import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueRouter from 'vue-router'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueNoty from 'vuejs-noty'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import globalMixin from '@/globalMixin'


Vue.use(Vuetify)
Vue.use(VueRouter)
Vue.use(Chartkick.use(Chart))
Vue.use(VueNoty)
Vue.use(VueSweetalert2);


Vue.config.productionTip = false

Vue.filter('currency', function (value) {
  const num = parseFloat(value || 0);
  if (isNaN(num)) return '0.00';
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.mixin(globalMixin)


import Dashboard from './my_project/components/Dashboard/Generate.vue'
import Login from './components/Login/Login.vue'
import Contact from './my_project/components/Contact.vue'
import Patients from './my_project/components/Patients/Patients.vue'
import PatientCreate from './my_project/components/Patients/Create.vue'
import PatientDetails from './my_project/components/Patients/Details.vue'

import UserLedger from './my_project/components/Users/Ledger.vue'
import UserList from './my_project/components/Users/Lists.vue'
import RoleList from './my_project/components/Users/RoleList.vue'
import AddRolePermission from './my_project/components/Users/AddRolePermission.vue'
import GroupList from "./my_project/components/Users/GroupList.vue";


// import Invoices from './my_project/components/Invoice/Invoice.vue'
import InvoiceCreate from './my_project/components/Invoice/InvoiceCreate.vue'
import InvoiceVoid from './my_project/components/Invoice/Void.vue'
import InvoiceRefund from './my_project/components/Invoice/Refund.vue'
import InvoiceDueCollection from './my_project/components/Invoice/InvoiceDueCollection.vue'
import InvoiceInvestigationCreate from './my_project/components/Invoice/CreateInvoiceInvestigation.vue'



import OtScheduleCreate from './my_project/components/OT/Schedule/Create.vue'
import OtSchedule from './my_project/components/OT/Schedule/List.vue'

import OtItems from './my_project/components/OT/Lists.vue'
import OtBillHead from './my_project/components/OT/Bill/BillHead.vue'
import OtBillCancel from './my_project/components/OT/Bill/CancelList.vue'
import OtBillDueList from './my_project/components/OT/Bill/DueList.vue'
import OtBillAdvanceList from './my_project/components/OT/Bill/AdvanceList.vue'

import OtBill from './my_project/components/OT/Bill/List.vue'
import OtBillInjection from './my_project/components/OT/Bill/Injection.vue'
import OtBillLaser from './my_project/components/OT/Bill/Laser.vue'
import OtBillCreate from './my_project/components/OT/Bill/Create.vue'
import OtBillList from './my_project/components/OT/Bill/BillList.vue'
import OtBillRefund from './my_project/components/OT/Bill/Refund.vue'
import OtBillReceived from './my_project/components/OT/Bill/Received.vue'

import OtBillCounselorIncentive from './my_project/components/OT/Setup/CounselorIncentive.vue'
import OtCounselor from './my_project/components/OT/Counseling/FollowupPatients.vue'
import OtCounselorData from './my_project/components/OT/Counseling/Data.vue'
import OtCounselorIncentive from './my_project/components/OT/Counseling/Incentive.vue'
import OtCounselorReport from './my_project/components/OT/Counseling/CounselingReport.vue'



import CardList from './my_project/components/Card/List.vue'
import CardAssignTo from './my_project/components/Card/AssignTo.vue'
import CardDetails from './my_project/components/Card/Details.vue'
import CardDashboard from './my_project/components/Card/Dashboard.vue'

import Investigation from './my_project/components/Investigation/List.vue'
import InvestigationEdit from './my_project/components/Investigation/Edit.vue'
import InvestigationReport from './my_project/components/Investigation/Report.vue'
import InvestigationReferrals from './my_project/components/Referrals/InvestigationReferrals.vue'
import InvestigationDoctorReferralReport from './my_project/components/Referrals/InvestigationDoctorReferralReport.vue'



import OpdInvoiceCreate from './my_project/components/OPD/OpdCreate.vue'

import OtRegistrationDetails from './my_project/components/OT/Registration/Details.vue'

import OtDischargeCertificate from './my_project/components/OT/Registration/DischargeCertificate.vue'
import OpticLensSetup from "@/my_project/components/Administrative/OpticLensSetup.vue";
import InvestigationSetup from "@/my_project/components/Administrative/InvestigationSetup.vue";
import Cabins from "@/my_project/components/CabinBooking/Cabins.vue";


import SmsDLRReport from './my_project/components/Sms/DLRReport.vue'
import SmsCampData from './my_project/components/Sms/SmsCampData.vue'

import FeeRatioSetup from './my_project/components/Administrative/FeeRatioSetup.vue'
import CorporateClintSetup from './my_project/components/Administrative/CorporateClintSetup.vue'
import ChamberInfo from './my_project/components/Administrative/ChamberInfo.vue'
import PaymentMethodSetup from './my_project/components/Administrative/PaymentMethod.vue'
import OtRoomSetup from './my_project/components/Administrative/OtRoomSetup.vue'



const AppointmentList = resolve => {
    require.ensure(['./my_project/components/Appointment/List.vue'], () => {
        resolve(require('./my_project/components/Appointment/List.vue'))
    })
}
const AppointmentCreate = resolve => {
    require.ensure(['./my_project/components/Appointment/Create.vue'], () => {
        resolve(require('./my_project/components/Appointment/Create.vue'))
    })
}

const PrescriptionsFollowupPatients = resolve => {
    require.ensure(['./my_project/components/Prescriptions/FollowupPatients.vue'], () => {
        resolve(require('./my_project/components/Prescriptions/FollowupPatients.vue'))
    })
}
const Prescriptions = resolve => {
    require.ensure(['./my_project/components/Prescriptions/List.vue'], () => {
        resolve(require('./my_project/components/Prescriptions/List.vue'))
    })
}

const LensItems = resolve => {
    require.ensure(['./my_project/components/Lens/Items.vue'], () => {
        resolve(require('./my_project/components/Lens/Items.vue'))
    })
}
const LensUsesReport = resolve => {
    require.ensure(['./my_project/components/Lens/UsesReport.vue'], () => {
        resolve(require('./my_project/components/Lens/UsesReport.vue'))
    })
}

const OtScheduleCancelList = resolve => {
    require.ensure(['./my_project/components/OT/Schedule/CancelList.vue'], () => {
        resolve(require('./my_project/components/OT/Schedule/CancelList.vue'))
    })
}

import InvoicesDueList from './my_project/components/Invoice/DueList.vue'
const Invoices = resolve => {
    require.ensure(['./my_project/components/Invoice/Invoice.vue'], () => {
        resolve(require('./my_project/components/Invoice/Invoice.vue'))
    })
}

const InvoiceCreateConsultancy = resolve => {
    require.ensure(['./my_project/components/Invoice/CreateInvoiceConsultation.vue'], () => {
        resolve(require('./my_project/components/Invoice/CreateInvoiceConsultation.vue'))
    })
}
const InvoiceReport = resolve => {
    require.ensure(['./my_project/components/Reports/InvoiceReport.vue'], () => {
        resolve(require('./my_project/components/Reports/InvoiceReport.vue'))
    })
}
const HospitalLedger = resolve => {
    require.ensure(['./my_project/components/Ledger/HospitalLedger.vue'], () => {
        resolve(require('./my_project/components/Ledger/HospitalLedger.vue'))
    })
}
const DoctorLedger = resolve => {
    require.ensure(['./my_project/components/Doctors/Ledger.vue'], () => {
        resolve(require('./my_project/components/Doctors/Ledger.vue'))
    })
}
const DoctorPaymentStatement = resolve => {
    require.ensure(['./my_project/components/Doctors/PaymentStatement.vue'], () => {
        resolve(require('./my_project/components/Doctors/PaymentStatement.vue'))
    })
}

const DoctorPayment = resolve => {
    require.ensure(['./my_project/components/Doctors/Payment.vue'], () => {
        resolve(require('./my_project/components/Doctors/Payment.vue'))
    })
}

const Doctors = resolve => {
    require.ensure(['./my_project/components/Doctors/List.vue'], () => {
        resolve(require('./my_project/components/Doctors/List.vue'))
    })
}
const DoctorDetails = resolve => {
    require.ensure(['./my_project/components/Doctors/View.vue'], () => {
        resolve(require('./my_project/components/Doctors/View.vue'))
    })
}

const VideoQrCodeData = resolve => {
    require.ensure(['./my_project/components/FileManager/QRCodeData.vue'], () => {
        resolve(require('./my_project/components/FileManager/QRCodeData.vue'))
    })
}


const logOut = resolve => {
    require.ensure(['./my_project/Logout.vue'], () => {
        resolve(require('./my_project/Logout.vue'))
    })
}

const vuetify = new Vuetify();
const routes = [
    { path: '/', component: Dashboard },
    { path: '/login', component: Login },
    { path: '/contact', component: Contact },

    { path: '/patient-create', component: PatientCreate },
    { path: '/patient-create/:id', component: PatientCreate },
    { path: '/patients', component: Patients },
    { path: '/patient-details/:id', component: PatientDetails },
    { path: '/appointment/create/:id', component: AppointmentCreate },

    { path: '/users/user-ledger', component: UserLedger },
    { path: '/users/user-list', component: UserList },
    { path: '/users/group-list', component: GroupList },
    { path: '/users/role-list', component: RoleList },
    { path: '/users/roles/add-role-permission', component: AddRolePermission },
    { path: '/users/roles/add-role-permission/:id', component: AddRolePermission },


    { path: '/prescription/list', component: Prescriptions },
    { path: '/prescription/followup-patients', component: PrescriptionsFollowupPatients },

    // { path: '/invoices', component: Invoices },
    // { path: '/invoices/:id', component: Invoices },

    { path: '/invoice-create/', component: InvoiceCreate },
    { path: '/invoice-create/:id', component: InvoiceCreate },
    { path: '/invoice/void-list', component: InvoiceVoid },
    { path: '/invoice/refund/:id', component: InvoiceRefund },
    { path: '/invoice/invoice-due-collection/:InvoiceId', component: InvoiceDueCollection },
    { path: '/invoice/invoice-create-investigation/:id', component: InvoiceInvestigationCreate },

    { path: '/ot-module/schedule-create', component: OtScheduleCreate },
    { path: '/ot-module/schedule', component: OtSchedule },
    { path: '/ot-module/schedule-cancel', component: OtScheduleCancelList },

    { path: '/ot-registration/:id', component: OtRegistrationDetails },

    { path: '/ot-module/counselor', component: OtCounselor },
    { path: '/ot-module/counseling-data', component: OtCounselorData },
    { path: '/ot-module/counselor-incentive', component: OtCounselorIncentive },
    { path: '/ot-module/ot-items', component: OtItems },
    { path: '/ot-module/ot-bill-head', component: OtBillHead },
    { path: '/ot-module/ot-bill-cancel', component: OtBillCancel },
    { path: '/ot-module/ot-bill-due-list', component: OtBillDueList },
    { path: '/ot-module/ot-bill-advance-list', component: OtBillAdvanceList },

    { path: '/lens-module/items', component: LensItems },
    { path: '/lens-module/used-report', component: LensUsesReport },
    { path: '/otbill-setup/counselor-incentive-setup', component: OtBillCounselorIncentive },
    { path: '/ot-counseling/counselor-report', component: OtCounselorReport },

    { path: '/ot-bill', component: OtBill },
    { path: '/ot-bill/injection', component: OtBillInjection },
    { path: '/ot-bill/laser', component: OtBillLaser },

    { path: '/otbill-create/:id', component: OtBillCreate },
    { path: '/otbill-list', component: OtBillList },
    { path: '/otbill-refund/:id', component: OtBillRefund },
    { path: '/otbill-received/:id', component: OtBillReceived },
    { path: '/file-manager/qrcode-data', component: VideoQrCodeData },


    { path: '/card', component: CardList },
    { path: '/card/dashboard', component: CardDashboard },
    { path: '/card/assign', component: CardAssignTo },
    { path: '/card/details/:id', component: CardDetails },

    { path: '/investigations', component: Investigation },
    { path: '/investigations/edit/:id', component: InvestigationEdit },
    { path: '/investigation/report', component: InvestigationReport },
    { path: '/referrals/investigation-referrals', component: InvestigationReferrals },
    { path: '/referrals/investigation-doctor-referral-report', component: InvestigationDoctorReferralReport },




    { path: '/doctors', component: Doctors },
    { path: '/doctor-details/:id', component: DoctorDetails },
    { path: '/doctor-ledger', component: DoctorLedger },
    { path: '/doctor-payment-statement/', component: DoctorPaymentStatement },
    { path: '/doctor-payment/', component: DoctorPayment },




    { path: '/ot-discharge-certificate/:id', component: OtDischargeCertificate },


//    opd patient data========
    { path: '/invoice/opd-invoice-create/:id', component: OpdInvoiceCreate },
    { path: '/appointment/all', component: AppointmentList },
    { path: '/invoices', component: Invoices },
    { path: '/invoice/due-list', component: InvoicesDueList },
    { path: '/invoices/:id', component: Invoices },
    { path: '/invoice/invoice-create-consultancy', component: InvoiceCreateConsultancy },
    { path: '/invoice/invoice-create-investigation/:id', component: InvoiceInvestigationCreate },
    { path: '/hospital-ledger', component: HospitalLedger },

    { path: '/sms/drl-report', component: SmsDLRReport },
    { path: '/sms/camp-data', component: SmsCampData },

    /* ======= Cabin Booking part =======  */
    { path: '/cabin-list', component: Cabins},
    /* ======= Cabin Booking part =======  */

    /*=====Start Report========== */
    { path: '/reports/invoice-report', component: InvoiceReport },

    /*======== Start Administrative==============*/

    { path: '/administrative/optic-lens-setup', component: OpticLensSetup },
    { path: '/administrative/investigation-setup', component: InvestigationSetup },
    { path: '/administrative/fee-and-ratio-setup', component: FeeRatioSetup },
    { path: '/administrative/corporate-client-setup', component: CorporateClintSetup },
    { path: '/administrative/chamber-info', component: ChamberInfo },
    { path: '/administrative/ot-room-setup', component: OtRoomSetup },
    { path: '/administrative/payment-method-setup', component: PaymentMethodSetup },

    /*======== End Administrative==============*/

    /*======End Report===========*/
    { path: '/logout', component: logOut },

]
const router = new VueRouter({
    mode: 'history',
    routes
});
Vue.mixin({
    data: function() {
        return {
            globalVar: 'global'
        }
    }
})
new Vue({
    vuetify,
    router,
    render: h => h(App),
}).$mount('#app')